import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_StepOne = _resolveComponent("StepOne")!
  const _component_StepThree = _resolveComponent("StepThree")!
  const _component_BottomNavigation = _resolveComponent("BottomNavigation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('administratif.navigation.equipements.header')) + " ", 1),
          _createVNode(_component_ReglePastille, { cle: "equipements.definition" })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.step === 1)
          ? (_openBlock(), _createBlock(_component_StepOne, {
              key: 0,
              title: _ctx.$t('administratif.navigation.equipements.search'),
              onNext: _ctx.next
            }, null, 8, ["title", "onNext"]))
          : _createCommentVNode("", true),
        (_ctx.step === 2)
          ? (_openBlock(), _createBlock(_component_StepThree, {
              key: 1,
              "display-radio": false,
              "open-info-equipement": true
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_BottomNavigation, {
      back: _ctx.back,
      cancel: _ctx.cancel,
      confirmButtonDisabled: !_ctx.isValid,
      first: _ctx.step === 1,
      last: _ctx.step === 2,
      next: _ctx.next,
      "no-validation": true
    }, null, 8, ["back", "cancel", "confirmButtonDisabled", "first", "last", "next"])
  ], 64))
}